// オンボーディングチェックリストの閉じるボタン
document.addEventListener('turbolinks:load', function() {
  var dismissBtn = document.querySelector('.onboarding-dismiss');
  if (!dismissBtn) return;

  dismissBtn.addEventListener('click', function() {
    var url = this.dataset.url;
    var section = document.getElementById('onboarding-checklist');

    fetch(url, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      }
    }).then(function(response) {
      if (response.ok) {
        section.style.transition = 'opacity 0.3s ease, max-height 0.3s ease';
        section.style.opacity = '0';
        section.style.maxHeight = '0';
        section.style.overflow = 'hidden';
        section.style.marginBottom = '0';
        section.style.padding = '0';
        setTimeout(function() { section.remove(); }, 300);
      }
    }).catch(function() {
      alert(dismissBtn.dataset.errorMessage);
    });
  });
});
